import { render, staticRenderFns } from "./AbkCompetencesList.vue?vue&type=template&id=33156b78&scoped=true&"
import script from "./AbkCompetencesList.vue?vue&type=script&lang=js&"
export * from "./AbkCompetencesList.vue?vue&type=script&lang=js&"
import style0 from "./AbkCompetencesList.vue?vue&type=style&index=0&id=33156b78&lang=scss&scoped=true&"
import style1 from "./AbkCompetencesList.vue?vue&type=style&index=1&id=33156b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33156b78",
  null
  
)

export default component.exports